import './AIProgressBar.css';

interface AIProgressBarProps {
  currentStep: number;
}

function AIProgressBar({ currentStep }: AIProgressBarProps) {
  const maxSteps = 5;
  const progressPercentage = (currentStep / maxSteps) * 100;

  return (
    <div className="ai-progress-bar">
      <div className="ai-progress-header">
        <span className="ai-progress-step">
          Step {currentStep} of {maxSteps}
        </span>
      </div>
      <div className="ai-progress-track">
        <div className="ai-progress-fill" style={{ width: `${progressPercentage}%` }} />
      </div>
    </div>
  );
}

export default AIProgressBar;
